import { BUDGET, BUDGET_USER } from 'business/constants';
import { ScopeT } from 'business/definitions';
import { useClientHasModule } from 'hooks/client';
import { useCallback } from 'react';
import { FINANCE_SCOPE } from 'routes/BudgetModule/config/constants';

/** Determines if the finance write scope editor should be displayed based on budget module access and user roles. */
export const useShouldDisplayUserWriteScopes = (userRoles: string[]) => {
    const hasBudgetModule = useClientHasModule(BUDGET);

    return useCallback(
        (scope: ScopeT) => {
            const isDefaultFinanceScope = scope.name === FINANCE_SCOPE;
            return (
                hasBudgetModule &&
                isDefaultFinanceScope &&
                userRoles.includes(BUDGET_USER)
            );
        },
        [hasBudgetModule, userRoles],
    );
};
